export let Positions = {
  Left: "left",
  Above: "above",
  InlineRight: "inline-right",
  InlineLeft: "inline-left",
  Below: "below",
  Right: "right",
  None: "none"
}